import Flickity from 'flickity'
import vsbl from 'vsbl'
require('flickity-bg-lazyload')
// FIXME: When importing flickity globally on theme.liquid it breaks importing it within single files!
//        see: https://github.com/metafizzy/flickity/issues/484

export default carousel => {
  const slideshow = carousel.querySelector('.js-collection-carousel')
  const rightArrow = carousel.querySelector('.js-carousel-left')
  const leftArrow = carousel.querySelector('.js-carousel-right')

  const header = carousel.querySelector('.js-collection-heading')

  vsbl(header)(() => {
    header.classList.add('is-visible')
  })

  vsbl(slideshow)(() => {
    slideshow.classList.add('is-visible')
  })

  if (slideshow) {
    const flkty = new Flickity(slideshow, {
      contain: true,
      prevNextButtons: false,
      // selectedAttraction: 0.01,
      // bgLazyLoad: true,
      bgLazyLoad: 1,
      lazyLoad: 1,
      pageDots: false,
      // friction: 0.15,
      wrapAround: true,
      autoPlay: false
    })

    flkty.on('dragStart', (event, pointer) => { document.ontouchmove = e => e.preventDefault() })
    flkty.on('dragEnd', (event, pointer) => { document.ontouchmove = e => true })

    setTimeout(() => {
      flkty.resize()
    }, 1500)

    rightArrow.addEventListener('click', () => {
      flkty.previous()
    })

    leftArrow.addEventListener('click', () => {
      flkty.next()
    })
  }
}



// WEBPACK FOOTER //
// ./src/scripts/components/collection-carousel.js